<template>
  <div>
    <img
      class="l-icon"
      :class="{ 'icon-animate': animate }"
      :src="getLikeIcon(flag)"
      alt=""
    />
  </div>
</template>
<script>
export default {
  props: {
    flag: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      animate: false
    }
  },
  watch: {
    flag() {
      this.animate = this.flag
    }
  },
  methods: {
    getLikeIcon(flag) {
      return flag
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c73e7e460544f7db1a959427432c6fb5.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a72c1d0a7d610f2d40bffd7bd55d1e18.png'
    }
  }
}
</script>
<style lang="scss" scoped>
.l-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.icon-animate {
  animation: myscale 0.3s ease;
}

@keyframes myscale {
  0% {
    transform: scale(0.6);
  }

  80% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
